import { EditorState } from "@/common/editor/RuleAuthor/multiEditor";
import { ELEMENT_TABLE } from "@udecode/plate-table";
import { usePlateEditorState } from "@udecode/plate-core";
import { EditorToolbarButton, type EditorToolbarButtonProps } from "../../plugins/toolbar";

// Table toolbar button needs to only be enabled if within a table

export type TableToolbarButtonProps = Omit<EditorToolbarButtonProps, "onClick" | "type"> & {
  transform: (editor: any, options?: any) => void;
  options?: any;
  hide?: boolean | ((editor: any) => boolean);
};

/**
 * Table Toolbar button to perform transforms on selection.
 */
export const TableToolbarButton = ({ transform, options, hide, ...props }: TableToolbarButtonProps) => {
  const editorState = usePlateEditorState(EditorState.rules);
  const hidden = typeof hide === "function" ? hide(editorState) : hide;
  const disabled = typeof props.disable === "function" ? props.disable(editorState) : props.disable;
  const handleClick = (editor: any) => transform(editor, options);

  if (hidden) return null;
  if (props.hideDisabled && disabled) return null;

  return (
    <EditorToolbarButton
      id={EditorState.rules}
      type={ELEMENT_TABLE}
      onClick={handleClick}
      {...props}
      disable={disabled}
      hideDisabled={false}
    />
  );
};
